var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'sw-image-placeholder': true,
        'sw-image-placeholder_wide': _vm.wide,
        'sw-image-placeholder_roundings_none': _vm.$simlaweb.settings.roundings === _vm.ROUNDINGS.NONE,
        'sw-image-placeholder_roundings_small': _vm.$simlaweb.settings.roundings === _vm.ROUNDINGS.SMALL,
        'sw-image-placeholder_roundings_large': _vm.$simlaweb.settings.roundings === _vm.ROUNDINGS.LARGE
    }},[_c('div',{staticClass:"sw-image-placeholder__inner"},[_c('SvgSpritePicture')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }